import { MapUiTheme } from '../../common';

export const buttonGroupTheme = {
  defaultStyles: {
    display: 'block',
  },
  notAttached: {
    '& > *:not(style)': {
      display: 'inline-block',
    },
    '& > *:not(style) ~ *:not(style)': {
      marginLeft: (theme: MapUiTheme) => theme.spacing[3],
    },
  },
  attached: {
    '& > *:first-of-type:not(:last-of-type)': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
    '& > *:not(:first-of-type):not(:last-of-type)': {
      borderRadius: 0,
    },
    '& > *:not(:first-of-type):last-of-type': {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
  },
};
